import {
  Component,
  ElementRef,
  inject,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { ButtonsModule, DropDownButtonComponent, KENDO_BUTTONS } from '@progress/kendo-angular-buttons';
import {
  IconsModule,
  KENDO_ICONS,
  SVGIcon,
  SVGIconModule,
} from '@progress/kendo-angular-icons';
import {
  bellIcon,
  xIcon,
  chevronRightIcon,
  checkCircleIcon,
  checkOutlineIcon,
  cancelOutlineIcon,
  arrowRightIcon,
} from '@progress/kendo-svg-icons';
import { NotificationsService } from '../../services/notifications.service';
import { Subscription } from 'rxjs';
import { IAlertNotificationDetails } from '../../models/notification.model';
import { Roles } from '../../constants/roles';
import { RequestService } from '../../services/request.service';
import { EngagementrequestService } from '../../services/engagementrequest.service';
import { UserrequestService } from '../../services/userrequest.service';
import { ModulerequestService } from '../../services/modulerequest.service';
import { AuthUserService } from '../../shared/auth/auth-user.service';
import { RequestType } from '../../constants/requestType';
import { RequestEngagementActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-engagement-activity-panel/request-engagement-activity-panel.component';
import { RequestAddUserActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-add-user-activity-panel/request-add-user-activity-panel.component';
import { RequestModuleActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-module-activity-panel/request-module-activity-panel.component';
import { RequestRemoveUserActivityPanelComponent } from '../shared/request-panel/activity-wrapper/request-remove-user-activity-panel/request-remove-user-activity-panel.component';
import { Router } from '@angular/router';
import { KENDO_LAYOUT, LayoutModule } from '@progress/kendo-angular-layout';
import { GridModule } from '@progress/kendo-angular-grid';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { InputsModule, SliderModule } from '@progress/kendo-angular-inputs';
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { LabelModule } from '@progress/kendo-angular-label';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { ListViewModule } from '@progress/kendo-angular-listview';
import { GaugesModule } from '@progress/kendo-angular-gauges';
import { ProgressBarModule } from '@progress/kendo-angular-progressbar';
import { IntlModule } from '@progress/kendo-angular-intl';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { RefreshGridService } from '../../shared/services/refresh-grid.service';

@Component({
  selector: 'notification-bell',
  standalone: true,
  imports: [
    ButtonsModule,
    SVGIconModule,
    KENDO_LAYOUT,
    KENDO_ICONS,
    KENDO_BUTTONS,
    GridModule,
    ChartsModule,
    InputsModule,
    SliderModule,
    LayoutModule,
    ScrollViewModule,
    IconsModule,
    ButtonsModule,
    LabelModule,
    DropDownsModule,
    ListViewModule,
    GaugesModule,
    ProgressBarModule,
    IntlModule,
    RequestEngagementActivityPanelComponent,
    RequestAddUserActivityPanelComponent,
    RequestModuleActivityPanelComponent,
    RequestRemoveUserActivityPanelComponent,
    IndicatorsModule
],
  templateUrl: './notification-bell.component.html',
  styleUrls: ['./notification-bell.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificationBellComponent {
  //@Input() anchor!: ElementRef<HTMLElement> | HTMLElement;
  //@Input() openApproveOrDenyEngagementPopup = false;
  // positional inputs
  //@Input() popupAlign: Align = { horizontal: 'left', vertical: 'top' };
  //@Input() anchorAlign: Align = { horizontal: 'left', vertical: 'top' };
  //@Input() offset: Offset = { top: 0, left: 0 };
  //@Input() margin: number = 0;
  //@Input() positionMode: 'fixed' | 'absolute' = 'fixed';
  // sizing via CSS class
  //@Input() popupClass?: string | string[];
  //@Output() closeEvent = new EventEmitter<void>();
  //@ViewChild('popup') popup!: PopupComponent;

  public bellIcon: SVGIcon = bellIcon;
  public closeIcon: SVGIcon = xIcon;
  public actionIcon: SVGIcon = chevronRightIcon;
  public emptyNotification: SVGIcon = checkCircleIcon;
  public ApprovedNotification: SVGIcon = checkOutlineIcon;
  public RejectedNotification: SVGIcon = cancelOutlineIcon;
  public PendingNotification: SVGIcon = arrowRightIcon;
  public CompletedNotification: SVGIcon = checkCircleIcon;

  public alertNotificationsList: IAlertNotificationDetails[] | undefined = [];

  //This is to test the UI locally
  //public
  //];
  public alertNotificationItem: IAlertNotificationDetails | undefined;

  public readonly userRole = Roles;
  private subscription!: Subscription;
  public loggedInUserRole: string | undefined;

  public selectedRequestId: any;
  public selectedEngagementDetail: any;
  public isEngagementRequestPopupOpen = false;
  public isApprovalUser = false;
  public isUserAddRequestPopupOpen = false;
  public isModuleRequestPopupOpen = false;
  public isUserRemovePopupOpen: boolean = false;
  public selectedModuleDetail: any;
  public selectedRemovalUserData: any;

  public requestStatus: string = '';
  public userAddDetails: any;

  @ViewChild('anchor', { static: true }) anchor!: ElementRef;
  @ViewChild(RequestEngagementActivityPanelComponent)
  requestEngagementActivityPanelComponent!: RequestEngagementActivityPanelComponent;
  @ViewChild(RequestAddUserActivityPanelComponent)
  requestAddUserActivityPanelComponent!: RequestAddUserActivityPanelComponent;
  @ViewChild(RequestModuleActivityPanelComponent)
  requestModuleActivityPanelComponent!: RequestModuleActivityPanelComponent;
  @ViewChild(RequestRemoveUserActivityPanelComponent)
  requestRemoveUserActivityPanelComponent!: RequestRemoveUserActivityPanelComponent;
  @ViewChild('notificationDropdown') notificationDropdown!: DropDownButtonComponent;
  // Roles.GeneralUserRole
  // Roles.EngagementApproverUserRole
  // Roles.SupportUserRole
  public noNotificationFlag: boolean = false;
  private readonly authUserService = inject(AuthUserService);
  private readonly notificationsService = inject(NotificationsService);
  private readonly engagementrequestService = inject(EngagementrequestService);
  private readonly userrequestService = inject(UserrequestService);
  private readonly modulerequestService = inject(ModulerequestService);
  private readonly refreshGridService = inject(RefreshGridService);

  constructor() {
    this.refreshGridService.refreshNotificationBell$.subscribe(() => {
      this.subscription = this.notificationsService
      .getAlertNotificationsDetailsAsync$() //ToDo: Get the current user
      .subscribe((notifications) => {
        if (notifications.data && notifications.data.length > 0) {
          this.alertNotificationsList = notifications.data;
        } else {
          this.alertNotificationsList = this.fillNoNotificationItem();
          this.noNotificationFlag = true;
        }
      });
    });

  }

  ngOnInit() {
    this.refreshGridService.emitNotificationBellRefresh()
    type RoleKey = keyof typeof Roles;
    this.authUserService.loggedInUserProfile.subscribe((userRole) => {
      // this.loggedInUserRole = (Object.keys(Roles) as RoleKey[])
      //   .find(k => Roles[k] === userRole);
      this.loggedInUserRole = userRole;
      //console.log('UserRole - from Notification Component: ', this.loggedInUserRole)
    });
  }

  onDropdownButtonClick(event: any) {
    event.preventClose = true;
  }

  // #region Popups

  // #region Engagement

  public getEngagementDetailsByRequestId(requestId: number): void {
    this.engagementrequestService
      .getEngagementDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.selectedEngagementDetail = x.data;
        this.selectedRequestId = requestId;
      });
  }

  onEngagementRequestPopupClose(): void {
    this.isEngagementRequestPopupOpen = false;
    this.requestStatus = '';
    this.selectedEngagementDetail = null;
    this.reset();
  }

  // #endregion

  // #region Module

  public getModuleDetailsByRequestId(
    requestId: number
  ): void {
    this.modulerequestService
      .getModuleRequestDetailsByRequestId(requestId)

      .subscribe((x) => {
        this.selectedModuleDetail = x.data;
        this.selectedRequestId = requestId;
      });
  }

  onModuleRequestPopupClose(): void {
    this.isModuleRequestPopupOpen = false;
    this.requestStatus = '';
    this.selectedModuleDetail = null;
    this.reset();
  }

  // #endregion

  // #region Add User

  public getUserDetailsByRequestId(requestId: number): void {
    this.userrequestService
      .getUserDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.userAddDetails = x.data;
        this.selectedRequestId = requestId;
      });
  }

  onUserAddRequestPopupClose(): void {
    this.isUserAddRequestPopupOpen = false;
    this.requestStatus = '';
    this.userAddDetails = null;
    this.reset();
  }

  // #endregion

  // #region Remove User

  public getUserRemoveDetailsByRequestId(
    requestId: number
  ): void {
    this.userrequestService
      .getUserRemovalDetailsByRequestId(requestId)
      .subscribe((x) => {
        this.selectedRemovalUserData = x.data;
        this.selectedRequestId = requestId;
      });
  }

  closeRemoveUserPopup(): void {
    this.isUserRemovePopupOpen = false;
    this.selectedRemovalUserData = null;
    this.requestStatus = '';
    this.reset();
  }

  // #endregion

  // #endregion

  reset(): void {
    //this.router.navigate(['/']);
  }

  removeNotification(userAlertNotificationId: number): void {
    this.notificationsService
      .updateNotificationAsReadAsync$(userAlertNotificationId)
      .subscribe((isRead) => {
        if (isRead)
          this.alertNotificationsList = this.alertNotificationsList?.filter(
            (n) => n.alertNotificationId !== userAlertNotificationId
          );
        this.notificationDropdown.toggle(false);
      });
  }

  fillNoNotificationItem(): IAlertNotificationDetails[] | undefined {
    var noNotificationAlertNotificationsList:
      | IAlertNotificationDetails[]
      | undefined = [
        {
          requestId: -1,
          requestTypeId: -1,
          requestType: 'No Request',
          requestStatusId: -1,
          requestStatus: '',
          comment: '',
          approvalUserId: '',
          approvalUserEmail: '',
          supportUserId: '',
          supportUserEmail: '',
          subject: 'No Requests',
          notificationId: -1,
          notificationTypeId: -1,
          notificationType: 'No Request',
          notificationStatusId: -1,
          alertNotificationId: -1,
          isRead: false,
          createdBy: 'admin',
          createdDate: '',
          modifiedBy: 'admin',
          modifiedDate: '',
        },
      ];
    return noNotificationAlertNotificationsList;
  }

  onEngagementRequestCellClick(requestDetail: any): void {
    this.notificationDropdown.toggle(false);
    this.requestStatus = requestDetail?.requestStatus;
    if (this.loggedInUserRole === this.userRole.EngagementApproverUserRole) {
      this.isApprovalUser = true;
    }

    if (requestDetail.requestType === RequestType.AddEngagement) {
      this.getEngagementDetailsByRequestId(requestDetail.requestId);
      this.isEngagementRequestPopupOpen = true;
    } else if (requestDetail.requestType === RequestType.AddUser) {
      this.getUserDetailsByRequestId(requestDetail.requestId);
      this.isUserAddRequestPopupOpen = true;
    } else if (requestDetail.requestType === RequestType.AddModule) {
      this.getModuleDetailsByRequestId(requestDetail.requestId);
      this.isModuleRequestPopupOpen = true;
      // this.approveOrDenyModuleComponent.open();
    } else if (requestDetail.requestType === RequestType.RemoveUser) {
      this.getUserRemoveDetailsByRequestId(requestDetail.requestId);
      this.isUserRemovePopupOpen = true;
      // this.approveOrDenyUserRemovalComponent.open();
    }
    this.removeNotification(requestDetail.alertNotificationId);
  }
}
